var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvoi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.4 25.3",
    style: {
      enableBackground: "new 0 0 25.4 25.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.1,1.4 25.1,1.4 25.1,1.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M24.8,1.1C24.7,1.1,24.7,1.1,24.8,1.1c-0.1-0.2-0.1-0.3-0.2-0.3s-0.1-0.1-0.3-0.2c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.2,0l-0.1,0c-0.1,0-0.2,0-0.2,0L0.9,8C0.5,8.1,0.3,8.4,0.3,8.8c0,0.4,0.2,0.7,0.5,0.8l10.6,4.3l4.3,10.6 c0.1,0.3,0.5,0.6,0.8,0.5c0.4,0,0.7-0.3,0.8-0.6l7.4-22.8c0-0.1,0-0.2,0-0.3l0-0.1C24.8,1.3,24.8,1.2,24.8,1.1z M3.7,8.9l17-5.5 l-8.8,8.8L3.7,8.9z M16.5,21.6l-3.3-8.2L22,4.6L16.5,21.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvoi);
export default __webpack_public_path__ + "static/media/Envoi.0ec93fff.svg";
export { ForwardRef as ReactComponent };